import React from "react";
import { Link,Outlet } from "react-router-dom";
import "./communicate.css"
export default function FarmerCommunicate(){

    return (
        <div>
            <div className=" flex flex-row space-x-2 landing-page sm:text-sm">
            <Link to="admins" className="hover:text-blue-500">Admins</Link>
            <Link to="customers" className="hover:text-blue-500">Customers</Link>
            <Link to="bankOwners" className="hover:text-blue-500">bankOwners</Link>
            <Link to="hotelOwners" className="hover:text-blue-500">hotelOwners</Link>
            <Link to="transOwners" className="hover:text-blue-500">transOwners</Link>
            </div>
            <Outlet/>
        </div>
    )
}